import { CapacitorHttp } from '@capacitor/core'

import { isElectron } from '@/utils/device-type'

class LCapacitorHttp {
  async post(url: string, headers: any, data: any) {
    const options = {
      url,
      headers,
      data
    }
    const response = await CapacitorHttp.post(options)
    return response
  }
  async get(url: string, headers: any, params: any) {
    const options = {
      url,
      headers,
      params
    }
    const response = await CapacitorHttp.get(options)
    return response
  }

  async put(url: string, headers: any, data: any) {
    const options = {
      url,
      headers,
      data
    }
    const response = await CapacitorHttp.put(options)
    return response
  }
}

class ElectronHttp {
  private https: any
  private http: any

  constructor() {
    this.https = window.require('https')
    this.http = window.require('http')
  }

  async post(url: string, headers: any, data: any) {
    return new Promise((resolve, reject) => {
      const urlObject = new URL(url)
      const protocol = urlObject.protocol
      const caller = protocol == 'https:' ? this.https : this.http
      const defaultPort = protocol == 'https:' ? 443 : 80
      const req = caller.request(
        {
          hostname: urlObject.hostname,
          port: urlObject.port || defaultPort,
          method: 'POST',
          path: urlObject.pathname + urlObject.search,
          rejectUnauthorized: false,
          headers
        },
        (res: any) => {
          let body = ''
          res.on('data', (chunk: any) => {
            body += chunk
          })
          res.on('end', () => {
            resolve({ data: body })
          })
        }
      )

      req.on('error', (error: any) => {
        reject(new Error(`Request error: ${error.message}`))
      })

      req.write(data)
      req.end()
    })
  }

  async get(url: string, headers: any, params: any) {
    return new Promise((resolve, reject) => {
      const urlObject = new URL(url)
      const protocol = urlObject.protocol
      const caller = protocol == 'https:' ? this.https : this.http
      const defaultPort = protocol == 'https:' ? 443 : 80
      const req = caller.request(
        {
          hostname: urlObject.hostname,
          port: urlObject.port || defaultPort,
          method: 'GET',
          path: urlObject.pathname + '?' + new URLSearchParams(params),
          rejectUnauthorized: false,
          headers
        },
        (res: any) => {
          let body = ''
          res.on('data', (chunk: any) => {
            body += chunk
          })
          res.on('end', () => {
            resolve({ data: JSON.parse(body) })
          })
        }
      )

      req.on('error', (error: any) => {
        reject(new Error(`Request error: ${error.message}`))
      })

      req.end()
    })
  }

  async put(url: string, headers: any, data: any) {
    return new Promise((resolve, reject) => {
      const urlObject = new URL(url)
      const protocol = urlObject.protocol
      const caller = protocol == 'https:' ? this.https : this.http
      const defaultPort = protocol == 'https:' ? 443 : 80
      const req = caller.request(
        {
          hostname: urlObject.hostname,
          port: urlObject.port || defaultPort,
          method: 'PUT',
          path: urlObject.pathname + urlObject.search,
          rejectUnauthorized: false,
          headers
        },
        (res: any) => {
          let body = ''
          res.on('data', (chunk: any) => {
            body += chunk
          })
          res.on('end', () => {
            resolve({ data: body })
          })
        }
      )

      req.on('error', (error: any) => {
        reject(new Error(`Request error: ${error.message}`))
      })

      req.write(data)
      req.end()
    })
  }
}

class HttpFactory {
  static getHttp() {
    if (isElectron) {
      return new ElectronHttp()
    } else {
      return new LCapacitorHttp()
    }
  }
}
export default HttpFactory
